"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("./schema");
var card_1 = require("./card");
var event_1 = require("../event");
// TODO 为了编译不报错，下次有break-change可以去掉这个范型
var SylPlugin = /** @class */ (function () {
    function SylPlugin() {
        this.name = null;
        this.$controller = null;
        this.$schemaMeta = null;
        this.$NodeView = null;
        this.Controller = null;
        this.Schema = null;
        this.store = null;
        this.editor = null;
    }
    SylPlugin.prototype.init = function (status, options) {
        this.store = status.store;
        this.editor = status.editor;
        if (this.Controller) {
            this.$controller = new this.Controller(this.editor, this.store, options.controllerProps);
            this.editor.on(event_1.EventChannel.LocalEvent.EDITOR_WILL_UNMOUNT, this.$controller.editorWillUnmount.bind(this.$controller));
        }
        if (this.Schema) {
            var _a = schemaMetaFactory(this.Schema, this.editor, options), view = _a.view, meta = _a.meta;
            this.$NodeView = view;
            if (this.$NodeView && options.layers) {
                this.$NodeView.prototype.layers = options.layers;
            }
            this.$schemaMeta = meta;
        }
    };
    return SylPlugin;
}());
exports.SylPlugin = SylPlugin;
var SylUnionPlugin = /** @class */ (function () {
    function SylUnionPlugin() {
    }
    SylUnionPlugin.prototype.init = function (editor, props) {
        return {};
    };
    return SylUnionPlugin;
}());
exports.SylUnionPlugin = SylUnionPlugin;
/**
 * create normal schema meta
 * @param Ctor
 * @param editor
 * @param props
 */
function schemaMetaFactory(Ctor, editor, props) {
    // TODO 卡片节点直接取值导致很难对meta做处理
    if (schema_1.SylSchema.isCard(Ctor) && card_1.BaseCard.isPrototypeOf(Ctor)) {
        return {
            view: Ctor,
            meta: Reflect.getMetadata(schema_1.META, Ctor)
        };
    }
    else {
        var type = schema_1.SylSchema.getType(Ctor);
        !Boolean(type) && console.error('has no type of', Ctor.name);
        var $schema = new Ctor(editor, props.controllerProps);
        var meta = new schema_1.SchemaMeta(schema_1.FORMAT_TYPE[type], $schema.name, $schema);
        return {
            view: Ctor.NodeView || null,
            meta: meta
        };
    }
}
//# sourceMappingURL=syl-plugin.js.map